import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { isProduction } from '../../utility/config/environments.js'
import { isInvestorAdvisorOrInstitutional } from '../../../global/authentication/authentication-manager'
import { useFetch, buildBundleUrl } from './services.js'

const DisclosureLinks = () => {
  const site = isInvestorAdvisorOrInstitutional()
  const bundleUrl = {
    advisor: {
      bundleName: 'cti-common.footer',
      legalKeys: ['privacy', 'terms', 'entities', 'disclosures', 'glossary'],
    },
    investor: {
      bundleName: 'cti-investor.footer',
      legalKeys: ['privacy', 'terms', 'entities', 'disclosures', 'glossary'],
    },
    institutional: {
      bundleName: 'cti-institutional.footer',
      legalKeys: ['privacy', 'agreement', 'disclosures'],
    },
  }
  const { bundleName, legalKeys } = bundleUrl[site]
  const url = buildBundleUrl(bundleName)
  const { data, isError, isLoading } = useFetch(url)

  if (isError || isLoading) return <div></div>

  const bundle = data.bundles.default
  const resourceGroup = legalKeys.map((key) => {
    return {
      key,
      label: bundle[`legal-${key}.label`],
      url: bundle[`legal-${key}.url`],
    }
  })

  return (
    <div
      id="disclosureLink"
      className="u-marginBottom5gu u-sm-flex u-sm-flexCol u-sm-flexAlignItemsCenter"
      data-qa-automation="footer-disclosure-links"
    >
      {resourceGroup.map((el) => {
        return (
          <span key={el.key} id={el.label} className="Footer-legalLink">
            <a
              className="Link u-textSizeMsrm1"
              href={el.url}
              dangerouslySetInnerHTML={{ __html: el.label }}
            ></a>
          </span>
        )
      })}
    </div>
  )
}

export default function FooterDisclosureLinks(props) {
  return (
    <ErrorBoundary
      fallbackRender={() =>
        !isProduction() ? <p>Error in DisclosureLinks component</p> : null
      }
    >
      <DisclosureLinks {...props}></DisclosureLinks>
    </ErrorBoundary>
  )
}
